// ANCHOR React
import { useEffect, useState } from 'react';

// ANCHOR Models
import {
  useUpdateFormQuestionPointsPossible,
} from '@lyon/scoped-models/form/update/UpdateFormQuestionForm';
import { useFormQuestionAnswersData } from '@lyon/scoped-models/form/FormQuestionAnswersData';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { FormField } from '@lyon/components/utils/FormField';

// ANCHOR Constants
import { PLACEHOLDER, TITLE } from './constants';

export const LyonUpdateCheckboxPointsPossible = constant(() => {
  const answers = useFormQuestionAnswersData();
  const [points, setPoints, submit] = useUpdateFormQuestionPointsPossible();
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (answers) {
      const highestPoint = answers.reduce((previous, current) => (
        previous + current.points
      ), 0);

      setCounter((current) => current + 1);
      setPoints(highestPoint);
    }
  }, [answers, setPoints]);

  useEffect(() => {
    if (points && counter > 1) {
      submit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [points]);

  const noAnswers = !answers || answers.length === 0;

  return (
    <FormField
      value={points ?? ''}
      label={TITLE}
      placeholder={PLACEHOLDER}
      disabled
      caption={noAnswers
        ? 'Points are attributed to choices. Add a choice to determine the max points for this question.'
        : undefined}
    />
  );
});
